import React from "react";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { VenueListDT } from "../../components/DataTables/VenueListDT";
import { useTenantScope } from "../../hooks/useTenantScope";
import { BenefitsMetricsTenantScopeHeader } from "../Reporting/components/BenefitsMetricsWidgets";

export const Venues = () => {
  const navigate = useNavigate();
  const tenantScope = useTenantScope();

  return (
    <div className="grid">
      <div className="col-12">
        <div className="p-card p-4">
          <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-3 mb-4">
            <h2 className="m-0">Venues</h2>
            <Button
              icon="pi pi-plus"
              rounded
              aria-label="Plus"
              size="small"
              onClick={() => navigate("new")}
            />
          </div>
          <BenefitsMetricsTenantScopeHeader tenantId={tenantScope.tenantId} />
          <VenueListDT />
        </div>
      </div>
    </div>
  );
};
